import { render, staticRenderFns } from "./CustomerRecharge.vue?vue&type=template&id=b0423f82&"
import script from "./CustomerRecharge.vue?vue&type=script&lang=js&"
export * from "./CustomerRecharge.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRecharge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports